"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
const hu_po_1 = __importDefault(require("./hu.po"));
exports.messages = [hu_po_1.default];
//# sourceMappingURL=index.js.map